let location_id = '';
$(document).on('click', '.show_courts', async function () {
    $('#courts_wrap').remove()
    $('#create_court_wrap').remove()
    $('#edit_court_wrap').remove()
    // close the calendar dialog element
    // document.querySelector('dialog').remove();
    renderLoadingOverlay();

    location_name = $(this).attr('data-location-name');
    location_id = $(this).attr('data-location-id');
    let date    = $(this).attr('data-date');
    courts      = await getCourts(location_id);
    show_courts(courts, date, location_name, location_id)
});


function show_courts(courts, date, location_name, location_id) {

    console.log(location_name)
    console.log(courts)
    let location_courts = '';

    if (courts.length == 1) {
        renderTimes(location_id, courts[0].id, date);
        return false;
    } else if (courts.length == 0) {
        location_courts = `
            <div class="p-4 mb-4 text-sm rounded-lg bg-gray-900 text-blue-400 m-2" role="alert">
              <i class="fad fa-warning mr-2"></i> No courts for this location
            </div>
        `;
    } else {
        for (court of courts) {
            // if (court.length > 0) {
                location_courts += `<button class="border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-black dark:text-white rounded p-4 text-xl cursor-pointer show_times" data-court-id="${court.id}" data-date="${date}" data-location-name="${location_name}" data-location-id="${location_id}">${court.name}</button>`;
            // }
        }
    }

    let courts_wrap = `
    <div id="courts_wrap" class="fixed !z-50 max-sm:top-1 inset-x-0 inset-y-0 top-0 sm:inset-0 overflow-autox bg-gray-900/80">
        <div id="courts_scroller" class="flex items-start sm:items-centers pt-8 justify-center h-screen overflow-y-auto close_courts transition-all duration-300">
            <div class="max-w-3xl mx-auto text-gray-400 w-[400px]">
                <div id="courts_content" class="bg-gray-100 dark:bg-gray-800 p-8 shadow rounded border border-gray-700 relative" style="display: none;">
                    <div class="text-md font-extrabold text-center dark:text-gray-100 mb-4">${location_name} - ${moment(date).format("Do MMMM YYYY")}</div>
                    <div id="close_courts" class="absolute top-1 right-1 cursor-pointer text-red-400 hover:bg-green-700/40 rounded-full w-8 h-8 flex justify-center items-center"><i class="fal fa-times text-xl"></i>
                    </div>
                    <div id="courts" class="flex flex-wrap justify-center gap-4"></div>
                    <div id="court_controls" class="grid xs:gap-1 sm:gap-2"></div>
                </div>
            </div>
        </div>
    </div>
    `;

    $('body').prepend(courts_wrap)
    $('#courts').append(location_courts)
    $('#courts_content').fadeIn(200);

    removeLoadingOverlay();

    $('#slide_in_courts').click();
}

$(document).on('click', '#close_courts, .close_courts', function () {
    $('#courts_wrap').fadeOut(200);
    setTimeout(function () {
        $('#courts_wrap').remove()
        $(`.trigger-calendar[data-location-id="${location_id}"]`).click();
    }, 200)
})

$(document).on('click', '#courts_content', function (event) {
    event.stopPropagation();
})

const getCourts = async (location_id) => {
    try {
        const response = await fetch(`/api/courts`, {
            method:  'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            body:    JSON.stringify({
                json:        true,
                location_id: location_id,
            })
        });
        return await response.json()
    } catch (error) {
        console.log(error)
    }
}
